import { FormActions } from "../../components/common/FormActions";
import {
  createColumn,
  createViewEdit,
  formatDate,
  getForm,
  stringifyName,
} from "../../utils/helpers";
import { URL_CONFIGURABLES } from "../../utils/urls";

export const useConfigurables = () => {
  const tableColumns = () => [
    {
      id: "name",
      header: "Name",
      filter: true,
    },
    {
      id: "key",
      header: "Key",
      filter: true,
    },
    ...["created_at", "actions"].map((item) => createColumn(item)),
  ];

  const tableData = (data: any) => [
    ...data?.map((item: any) => {
      const row = {
        ...item,
        key: item.key,
        created_at: formatDate(item.created_at),
        actions: (
          <FormActions actions={createViewEdit(URL_CONFIGURABLES, item?.id)} />
        ),
      };
      return row;
    }),
  ];

  const viewData = (item: any) => {
    return {
      name: item?.name,
      key: item?.key,
      created_at: formatDate(item?.created_at),
      created_by: stringifyName({ ...item?.created_by }),
    };
  };

  const formRoute = getForm(URL_CONFIGURABLES);
  return { tableColumns, tableData, formRoute, viewData };
};
